"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacebarRuleCleanup = exports.spacebarIsPressedRule = void 0;
let hasSpacebarListenerBeenAdded = false;
let hasSpacebarPressed = false;
const spacebarIsPressedRule = val => {
  if (!hasSpacebarListenerBeenAdded) {
    hasSpacebarListenerBeenAdded = true;
    window.addEventListener("keydown", spacebarListener);
  }
  return hasSpacebarPressed;
};
exports.spacebarIsPressedRule = spacebarIsPressedRule;
const spacebarListener = e => {
  if (e.key === " ") {
    hasSpacebarPressed = true;
  }
};
const spacebarRuleCleanup = () => {
  hasSpacebarPressed = false;
  hasSpacebarListenerBeenAdded = false;
  window.removeEventListener("keydown", spacebarListener);
};
exports.spacebarRuleCleanup = spacebarRuleCleanup;